var $ = global.jQuery,
    _ = require('lodash');

//https://gist.github.com/TravelingTechGuy/32454b95a50d296912b9
var objectToQueryString = function (obj) {
    var qs = _.reduce(obj, function (result, value, key) {
        if (!_.isNull(value) && !_.isUndefined(value)) {
            if (_.isArray(value)) {
                result += _.reduce(value, function (result1, value1) {
                    if (!_.isNull(value1) && !_.isUndefined(value1)) {
                        result1 += key + '=' + value1 + '&';
                        return result1
                    } else {
                        return result1;
                    }
                }, '')
            } else {
                result += key + '=' + value + '&';
            }
            return result;
        } else {
            return result
        }
    }, '').slice(0, -1);
    return qs;
}


function PostDeferred(controller, action, url, reqData, onData, onError, onException, onSessionExpiry) {

    var fullurl = global.apiEndpoint + controller + "/" + action + (url ? "/" + url : "");
        deferred = $.ajax(fullurl, { contentType: "application/json", type: "POST", data: reqData });

    // data, textStatus, jqXHR -  may need all 
    deferred.then(function (data) {

        // JsonErrorContent
        if (data && data.hasOwnProperty('PlatformApplication')) {
                
            console.log('ajax error encountered: ' + fullurl, reqData);
            console.log(data);
            typeof onError !== 'function' || onError(data);

        } else {
            console.log('ajax success: ' + fullurl, reqData);
            console.log(data);
            typeof onData !== 'function' || onData(data);
        }

    });

    deferred.fail(function (response) {
        console.log("failed Ajax call: " + fullurl, reqData);
        console.log(response);

        if (response.hasOwnProperty('responseText')) {

            var data = JSON.parse(response.responseText);
            console.log(data);
            if (data.ReasonCode && data.ReasonCode === "SessionExpired") {

                console.log('session expired - logging out unless override supplied');
                if (typeof onSessionExpiry !== 'function' || onSessionExpiry(data)) {
                    LogOut();
                }

                return;
            } 
        }


        var propogateException = typeof onException !== 'function' || onException(response);
        if (propogateException){
            $.event.trigger("comms_error", response); $.event.trigger("access_violation", response);
        }

    });

    return deferred;

}

function LegacyGetDeferred(controller, action, url, onData, onError, onException, onSessionExpiry) {

    var fullurl = global.apiEndpoint + controller + "/" + action + (url ? "?" + url : ""),

        deferred = $.ajax(fullurl, { type: "GET" });

    // ReSharper disable once InconsistentNaming
    // data, textStatus, jqXHR -  may need all 
    deferred.then(function (data) {

        // JsonErrorContent
        if (data && data.hasOwnProperty('PlatformApplication')) {

            console.log('ajax error encountered: ' + fullurl);
            console.log(data);
            typeof onError !== 'function' || onError(data);

        } else {
            console.log('ajax success: ' + fullurl);
            console.log(data);
            typeof onData !== 'function' || onData(data);
        }

    });

    deferred.fail(function (response) {
        console.log("failed Ajax call: " + fullurl);
        console.log(response);

        if (response.hasOwnProperty('responseText')) {

            var data = JSON.parse(response.responseText);
            console.log(data);
            if (data.ReasonCode && data.ReasonCode === "SessionExpired") {

                console.log('session expired - logging out unless override supplied');
                if (typeof onSessionExpiry !== 'function' || onSessionExpiry(data)) {
                    LogOut();
                }

                return;
            }
        }


        var propogateException = typeof onException !== 'function' || onException(response);
        if (propogateException) {
            $.event.trigger("comms_error", response); $.event.trigger("access_violation", response);
        }

    });

    return deferred;

}

function GetDeferred(controller, action, url) {

    var fullurl = global.apiEndpoint + controller + "/" + action + (url ? "?" + url : ""),
        deferred = $.ajax(fullurl, { type: "GET" });

    return deferred.then(function (data) {

        console.log('ajax result: ' + fullurl, data);

        var returnDeferred = $.Deferred();

        return (!data || !data.Content) ? returnDeferred.reject(data && data.ResultStatus)
                                        : returnDeferred.resolve(data.Content);

    });

}


function GetDefaultTimeoutMessage() { return 'The session has timed out, please click on the Field Portal link on the left of the menu and sign in again'; }
function GetUnexpectedErrorMessage() { return 'An  unexpected error occurred.' }

module.exports = {
    ObjectToQueryString: objectToQueryString,
    PostDeferred       : PostDeferred,
    GetDeferred        : GetDeferred
};